import React from "react";

const TextInput = ({
  onChange = null,
  onFocus = null,
  onBlur = null,
  onClick = null,
  onPaste = null,
  validate = (e) => e,
  refs = () => "",
  autoComplete = "on",
  label = null,
  placeholder = "",
  classes = "",
  id = `input-${Date.now()}`,
  shouldAutoFocus = false,
  name = "text-input",
  value = "",
  type = "text",
  disabled = false,
  error = false,
  readOnly = false,
  tabIndex = 0,
  onKeyPress = null,
  inputClass = "",
  prefix = null,
  inputWrapperClass = "",
  inputmode = "text",
  inputRef = "",
  showAnimatedLine = true,
}) => (
  <div className={`form-input text-input ${classes} ${error ? "form-input-error" : ""}`}>
    {label && (
      <label htmlFor={label.for} className={label.classes}>
        {label.content}
      </label>
    )}
    <span className={inputWrapperClass}>
      {prefix}
      <input
        type={type}
        placeholder={placeholder}
        name={name}
        id={id}
        className={inputClass}
        ref={inputRef || ((input) => refs(input))}
        disabled={disabled}
        readOnly={readOnly}
        autoFocus={shouldAutoFocus}
        value={value}
        tabIndex={tabIndex}
        autoComplete={autoComplete}
        onChange={(e) =>
          typeof onChange === "function"
            ? onChange(validate({ name: e.target.name, value: e.target.value }))
            : ""
        }
        onClick={(e) => (typeof onClick === "function" ? onClick() : "")}
        onFocus={(e) => (typeof onFocus === "function" ? onFocus() : "")}
        onBlur={(e) => (typeof onBlur === "function" ? onBlur(e) : "")}
        onPaste={(e) => (typeof onPaste === "function" ? onPaste(e) : "")}
        onKeyPress={onKeyPress}
        inputMode={inputmode}
      />
      {label && showAnimatedLine && <label htmlFor={label.for} className="animated-line" />}
    </span>
  </div>
);

export default TextInput;
